import { jsx as e } from "react/jsx-runtime";
import d from "classnames";
import a from "./index.es650.js";
import { PartialIcon as l } from "./index.es651.js";
import { CheckedmarkIcon as m } from "./index.es652.js";
const x = ({
  checked: o = !1,
  indeterminate: t = !1,
  disabled: r = !1,
  variant: c = "gray",
  testId: s = "mock-checkbox"
}) => {
  const n = d(a.checkbox, {
    [a["brand-checkbox"]]: c === "brand"
  }), i = t ? "indeterminate" : o ? "checked" : "unchecked";
  return /* @__PURE__ */ e("div", { className: a.root, "data-testid": s, role: "presentation", "aria-hidden": "true", children: /* @__PURE__ */ e(
    "div",
    {
      className: n,
      "data-state": i,
      "data-disabled": r ? "" : void 0,
      style: {
        pointerEvents: "none",
        opacity: r ? 0.3 : 1
      },
      children: /* @__PURE__ */ e("span", { children: t ? /* @__PURE__ */ e(l, {}) : o ? /* @__PURE__ */ e(m, {}) : null })
    }
  ) });
};
export {
  x as MockCheckbox
};
//# sourceMappingURL=index.es5569.js.map
